import React, { useEffect, useState, useContext } from 'react'
import { getAllBankAccountsByPsid } from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import { Accordion } from "views/pages/manage/common/commonComponents";
import { Card, CardBody, Col, Row } from 'reactstrap'
import { getReinitRefundReqBody, studentDetails } from './constants';
import { displayFile } from 'modules/studentRefund/refundApproval/view/constant';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import BankDetailsCard from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/BankDetailsCard';
import { userTypes, bankAccountTypes, studentRelationDropdown, EMPTY_FORM } from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/utils';
import AddEditBankAccountDialog from 'views/pages/manage/edpOps/studentDetails/paymentSummary/studentBankDetails/AddEditBankAccountDialog';
import { openInNewTab } from 'modules/studentRefund/common/services';
// import DocUploadModal from 'views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
// import UploadDocument from './UploadDocument';
import AccountDetailsFooter from './AccountDetailsFooter';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from "views/pages/manage/common/constant";
import { EyeIcon as EyeIcon2 } from "views/pages/manage//masters/studentFinancials/paymentCollection/manage-receipts/EyeIcon";
import { Tooltip } from "@mui/material";
import { CourseTermPopover } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant";
import { UserDetails } from "appContext";
import ReinitRefundDialog from './components/ReinitRefundDialog';
import EyeIcon from "assets/img/svg/svgComponents/EyeIcon";
import { REFUND_MANAGE_ACCOUNTS } from '../../../../views/pages/manage/edpOps/studentDetails/constant';
const _ = require("lodash");


const StudentRefundDetails = ({
    dropdownData,
    details,
    setLoader,
    loader
}) => {
    const [studentBankDetails, setStudentBankDetails] = useState([]);
    const [addEditBankDetailsInfo, setAddEditBankDetailsInfo] = useState({});
    // const [addAttachmentDialogOpen, setAddAttachmentDialogOpen] = useState(false);
    const [attachment, setAttachment] = useState({ attachmentKey: "" });
    const [courseMap, setCourseMap] = useState({});
    const userDetails = useContext(UserDetails);
    const [isReinitDialogOpen, setIsReinitDialogOpen] = useState(false);
    const [updateRefund, setUpdateRefund] = useState({});

    const getAllBankAccounts = async () => {
        try {
            setLoader(true);
            const data = await getAllBankAccountsByPsid(details?.psid);
            setStudentBankDetails(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    }

    const reinitRectificationRefund = async () => {
        // if (studentBankDetails?.length == 0) {
        //     return failureToast("Please add student  bank details first")
        // }
        try {
            setLoader(true);
            const primaryAccount = studentBankDetails?.find(
                acc => acc?.accountType?.toLowerCase() === "primary"
            )
            const reqObj = getReinitRefundReqBody(details, primaryAccount, attachment?.attachmentKey, userDetails);
            const resp = await fetchAllPostPromisedData(endpoint?.refund?.updateRefund, reqObj, "post");
            if (resp?.code === 200 && resp?.data?.status == 'SUCCESS') {
                const completionRefund = resp?.data?.refundResponse?.completionRefundDetails;
                setUpdateRefund(completionRefund);
                setIsReinitDialogOpen(true);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        details?.psid > 0 && getAllBankAccounts();
    }, [details?.psid])

     const editAccountDetails = (details) => {
 
         const { allBanks, allCountries } = dropdownData;
         const accountDetails = _.pick(details, Object.keys(EMPTY_FORM))
         const { bankMasterId, country, accountType, bankAccountType, accountRelation } = details;
 
         setAddEditBankDetailsInfo({
             isOpen: true,
             viewOnly: true,
             initialForm: {
                 ...accountDetails,
                 psid: details?.psid,
                 bank: allBanks?.find(bank => bank?.value === bankMasterId),
                 country: allCountries?.find(el => el?.value === country),
                 accountType: userTypes?.find(type => type?.value === accountType),
                 bankAccountType: bankAccountTypes?.find(type => type?.value === bankAccountType),
                 studentRelation: studentRelationDropdown?.find(rel => rel?.value === accountRelation)
             }
         })
     }

    const getFormatCol = (label = '', value = '', flag = false, index, showEye = false, descKey = "", showCourseEye = false) => {
        return <>
            <Col md={2} className='mt-24'>
                <div>
                    <div className='large-semi-bold label-color'>
                        {(value && value !== " ") ? Array.isArray(value) ? label == 'Request form' ? displayFile(value) : value.length ? value.join(', ') : '-' : value : label == 'PSERP ID' ? <span style={{ color: '#D29822' }}>In progress</span> : '-'}
                        {Array.isArray(value)}
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <div className='regular-small'>
                            {label}
                        </div>
                        {showEye && value ? (
                            <Tooltip title={descKey}>
                                <span style={{ cursor: "pointer" }}>
                                    <EyeIcon2 />
                                </span>
                            </Tooltip>
                        ) : null}
                        {showCourseEye && value ? (
                            <CourseTermPopover
                                courseId={details?.courseId}
                                term={details?.term}
                                courseTermMap={courseMap}
                                setCourseTermMap={setCourseMap} />
                        ) : null}
                    </div>
                </div>
            </Col>
            {flag && index == 4 ? <Col md={4} className='mt-24'></Col> : ''}

        </>
    }

    return (
        <>
            <Accordion
                title={
                    <div className='h3' style={{ color: '#262626' }}>
                        Student Details
                    </div>
                }
                titleClasses="w-100 mb-0">
                <Row>
                    {studentDetails.map((item, index) => {
                        return getFormatCol(item?.label, details?.[item?.key], false, index, item?.showEye, details?.[item?.descKey], item?.showCourseEye)
                    })}
                </Row>

                <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                 <Row>
                    <div className='mt-24 d-flex justify-content-between align-items-center w-100'>
                        <div className='h3' style={{ color: '#262626' }}>
                            Choose a paymode
                        </div>
                        <AButton
                            variant='outline'
                            size='xs'
                            className='mr-2'
                            onClick={() => {
                                openInNewTab(`edp/studentDetails/${details?.psid}?source=${REFUND_MANAGE_ACCOUNTS}`);
                            }}
                        >
                            Manage Accounts
                        </AButton>
                    </div>

                    <AddEditBankAccountDialog
                        dialogInfo={addEditBankDetailsInfo}
                        setDialogInfo={setAddEditBankDetailsInfo}
                        dropdownData={dropdownData}
                        setLoading={setLoader}
                        getAllBankAccounts={getAllBankAccounts}
                        key={JSON.stringify(addEditBankDetailsInfo)}
                    />

                    <div className='d-flex flex-start flex-wrap' style={{ gap: '0.5rem' }}>
                        {studentBankDetails?.map(details =>
                            <BankDetailsCard
                                key={details?.id}
                                accountDetails={details}
                                iconClickHandler={() => editAccountDetails(details)}
                                openDetailsDialogIcon={<EyeIcon />}
                            />
                        )}
                    </div>
                </Row>

                {/* <div className='mt-24' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>
                <Row>
                    <div className='mt-24 flex-column'>
                        <div className='h3' style={{ color: '#262626' }}>
                            Supporting Documents
                        </div>
                        <UploadDocument attachmentKey={attachment?.attachmentKey} setAttachment={setAttachment} setUploadDialogOpen={setAddAttachmentDialogOpen} />
                    </div>


                    <DocUploadModal
                        open={addAttachmentDialogOpen}
                        setOpen={setAddAttachmentDialogOpen}
                        acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                        maxUploadFileSize={5}
                        serviceName={'REFUND_SERVICE_ATTACHMENTS'}
                        uniqueKeyParameter={"completionRefundReInitFile"}
                        uploadedFileS3Key={attachment?.attachmentKey}
                        uploadedFileName={"Completion Refund Reinit"}
                        modalTitle={"Upload Attachment"}
                        saveHandler={(s3Key) => {
                            setAddAttachmentDialogOpen(false);
                            setAttachment({ attachmentKey: s3Key })
                        }}
                        modalProps={{ zIndex: 1500 }}
                        key={attachment?.attachmentKey}
                    />

                </Row>  */}
            </Accordion>
            <AccountDetailsFooter onClick={reinitRectificationRefund} />
            <ReinitRefundDialog isOpen={isReinitDialogOpen} updateRefund={updateRefund} loader={loader} />
        </>
    )
}

export default StudentRefundDetails;